export default __webpack_public_path__ + "static/media/practice-test-2.f5148704.csv";